import React, { useEffect, useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, {
  FreeMode,
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
} from "swiper";
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "@/layout/layout";
import Link from "next/link";
import Astrobanner from "@/assets/images/banner-astto.jpg";
import Astroimgq from "@/assets/images/ast1.jpg";
import arrowred from "@/assets/images/icon-right-arrow.svg";
import astw from "@/assets/images/astw.png";
import gline from "@/assets/images/line-gray.png";
import styles from "@/styles/astrodaily.module.scss";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { useRouter } from "next/router";
import moment from "moment";
import { wrapper } from "@/store";
import { setPath, setTitle, setMeta } from "@/store/slices/helmet";

const AstroDaily: NextPage = () => {
  const [data, setData] = useState<any>([]);
  const router = useRouter();

  const loadZodiac = async () => {
    try {
      const { data } = await httpClient.get(endpoints.astro.zodiacList());
      setData(data);
    } catch (error) {}
  };

  useEffect(() => {
    loadZodiac();
  }, []);

  return (
    <Layout>
      <div className={styles.astro_banner}>
        <Image src={Astrobanner} alt="" />
        <div className={styles.astro_banner_text}>
          <div className="container h_100">
            <div className={styles.astro_banner_main}>
              <div className={styles.astro_banner_main_text}>
                <h1>Daily Horoscope</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.horoscope_bg}>
        <div className="container">
          <div className={styles.horoscope_astro}>
            <div className={styles.horoscope_astro_head}>
              CHOOSE YOUR <strong>HOROSCOPE</strong>
            </div>
            <div className={styles.wline}>
              <Image src={gline} alt="" />
            </div>
            <div className="row justify-content-center mt-4 mb-4">
              <div className="col-md-12">
                <p className={styles.sub_head}>
                  Senco Gold & Diamonds is the name you can trust for accurate
                  online daily horoscope predictions. We aim at encouraging
                  people to stay optimistic. The daily predictions also include
                  your lucky number and lucky colour for the day depending on
                  your zodiac sign.
                </p>
                <p className={styles.sub_head}>
                  Our renowned astrologers consider the movement and position of
                  the sun, moon, stars and planets before giving you an idea of
                  what might happen on that day. Boost your confidence with our
                  Daily Horoscope services online.
                </p>
              </div>
            </div>
            <div className={styles.icon_container}>
              {!!data.length &&
                data.map((v: any) => (
                  <>
                    {" "}
                    <div
                      className={styles.col}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        router.push(`/astro/horoscope/${v.name}`);
                      }}
                    >
                      {/* <Link href="astrohoroscope" passHref> */}
                      <div className={styles.border_full}>
                        <div className={styles.icon_img}>
                          <Image
                            src={v.thumbnail_image}
                            alt=""
                            height={"200px"}
                            width={"200px"}
                          />
                        </div>
                        <p>
                          {v.name}
                          <br /> {moment(v?.start_date).format("MMMM DD")} -
                          {moment(v?.end_date).format("MMMM DD")}
                        </p>
                      </div>
                      {/* </Link> */}
                    </div>
                  </>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.choose_horoscope}>
        <div className="container">
          <div className={styles.heading}>
            Get Your Personalized <strong>Horoscope</strong>
          </div>
          <div className={styles.gline}>
            <Image src={gline} alt="" />
          </div>
          {/* <div className="row justify-content-center mt-4 mb-4">
            <div className="col-md-6">
              <p className={styles.sub_head}>
                Proin gravida nibh vel velit auctor aliquet. Aenean
                sollicitudin, lorem quis bibendum auctor, nisi elit consequat
                hello Aenean world.
              </p>
            </div>
          </div> */}
          <div className={styles.astro_bg_main}>
            <div className="row justify-content-center mt-4">
              <div className="col-md-4">
                <div className={styles.custom_card}>
                  <figure>
                    <Image src={Astroimgq} alt="" />
                  </figure>
                  <div className={styles.heading}>Astro Consultation</div>
                  <p>
                    Our astro consultation services are customized to help you
                    gain a deeper understanding of your personal life, health
                    and career.
                  </p>
                  <Link href="/astro/astrologers" passHref>
                    <div className={styles.more}>
                      <span>Book Now</span> <Image src={arrowred} alt="" />{" "}
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className={styles.custom_card}>
                  <figure>
                    <Image src={astw} alt="" />
                  </figure>
                  <div className={styles.heading}>Kundli </div>
                  <p>
                    Your Janam Kundli or Life Kushti can be the success tool of
                    your life. We also specialize in Kundli Matching services.
                  </p>
                  <Link href="/astro/kundali" passHref>
                    <div className={styles.more}>
                      <span>Book Now</span> <Image src={arrowred} alt="" />{" "}
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl }) => {
      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle("Daily Horoscope and Astrology | Senco Gold"));
      store.dispatch(
        setMeta({
          title: "Daily Horoscope and Astrology | Senco Gold",
          description:
            "Discover elegance at its finest with Senco Gold's best jewellery store near you. Explore exquisite designs crafted for every occasion.",
          keywords: "Daily Horoscope and Astrology | Senco Gold",
        })
      );

      return {
        props: {},
      };
    }
);

export default AstroDaily;
